import {
    LayoutDashboard,
    CalendarDays,
    createLucideIcon,
    CandlestickChart,
    NotebookPen,
    FilePlus2,
    Search
} from 'lucide-react';

// chart-no-axes-combined from Lucide; defined locally because the installed
// lucide-react version predates this icon.
export const ChartNoAxesCombined = createLucideIcon('ChartNoAxesCombined', [
    ['path', { d: 'M12 16v5' }],
    ['path', { d: 'M16 14.639V21' }],
    ['path', { d: 'M20 10.656V21' }],
    ['path', { d: 'm22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15' }],
    ['path', { d: 'M4 18.463V21' }],
    ['path', { d: 'M8 14.656V21' }],
]);

export const BLUE = '#3b82f6';
export const GREEN = '#10b981';
export const RED = '#ef4444';
export const YELLOW = '#f59e0b';

// Sidebar navigation items with lucide-react icons
export const NAV_ITEMS = [
    { name: 'Dashboard', icon: LayoutDashboard },
    { name: 'Calendar', icon: CalendarDays },
    { name: 'Reports', icon: ChartNoAxesCombined },
    { name: 'Trades', icon: CandlestickChart },
    { name: 'Journal', icon: NotebookPen },
    { name: 'New Trade', icon: FilePlus2 },
    { name: 'Search', icon: Search },
    // Settings removed from main navigation (accessible via user menu)
] as const;

export { default as extendedTimezones } from './timezones';
